import { Badge } from "@/components/ui/badge";
import type { Property } from "@/types/property";

interface PropertyHeaderProps {
  property: Property;
}

export const PropertyHeader = ({ property }: PropertyHeaderProps) => {
  return (
    <div className="relative aspect-video">
      <img
        src={property.images[0] || "/placeholder-property.jpg"}
        alt={property.title}
        className="absolute inset-0 w-full h-full object-cover"
      />
      <Badge
        className="absolute top-2 right-2"
        variant={
          property.verification_status === "approved"
            ? "default"
            : property.verification_status === "rejected"
            ? "destructive"
            : "secondary"
        }
      >
        {property.verification_status}
      </Badge>
    </div>
  );
};